<script>
	import { createEventDispatcher } from "svelte";
	export let val = 0;

	const dispatch = createEventDispatcher();
	const increment = () => {
		val++;
		dispatch("chval", { val: 1 });
	};
	const decrement = () => {
		if (val == 0) return;
		val--;
		dispatch("chval", { val: -1 });
	};
</script>

<div>
	<button on:click={increment}>+</button>
	<span>{val}</span>
	<button on:click={decrement}>-</button>
</div>

<style>
	button {
		display: inline-block;
		width: 30px;
		border: 3px inset rgb(156, 156, 156);
		border-radius: 8px;
		padding: 6px;
		background-color: rgb(180, 220, 255);
		text-align: center;
		font-weight: bold;
		font-size: 22px;
        cursor: pointer;
	}
	span {
		position: relative;
		display: inline-block;
		width: 90px;
		border: 1px solid black;
		background-color: rgb(215, 252, 255);
		border-radius: 6px;
		padding: 6px;
		text-align: center;
		font-weight: bold;
		font-size: 22px;
	}
	div {
		display: flex;
		justify-content: center;
		border-radius: 6px;
        border-bottom: 2px outset rgb(240, 31, 16);

		padding: 3px;
		margin: auto;
		margin-top: 2px;
		/* border:1px solid red; */
		background-color: aliceblue;
	}
</style>
